import ApiService from "../../commons/services/ApiService";
import CompanyAPI from "../company/CompanyAPI";

const apiService = new ApiService();
export default class AdvancesAPI {

    URI_V1 = "/v1/advances"

    create = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

    update = async (id: any, data: any) => {
        return await apiService.put(`${this.URI_V1}/${id}`, data);
    };

    delete = async (id: any) => {
        return await apiService.delete(`${this.URI_V1}/${id}`);
    };

    findAll = async (filter: any) => {
        const companyAPI = new CompanyAPI();
        var query = `startDate=${filter.startDate}&endDate=${filter.endDate}&companyId=${companyAPI.getCompanyManagment().id}`;
        if(filter.employeeId) {
            query = `${query}&employeeId=${filter.employeeId}`
        }
        return await apiService.get(`${this.URI_V1}?${query}`);
    };
}
